import { render, staticRenderFns } from "./TheClasificaseChatModal.vue?vue&type=template&id=1bcacc7f"
import script from "./TheClasificaseChatModal.vue?vue&type=script&lang=js"
export * from "./TheClasificaseChatModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports